import { DEFAULT_CULTURE } from '@app/utils/regional'

import { extendLocaleWithLatinNumerics } from './extendLocaleWithLatinNumerics'
import { getNumberFormat } from './getNumberFormat'

export const getNumberFormatted = (value: number, culture?: string) => {
  if (!Number.isFinite(value)) {
    return ''
  }

  const locale = extendLocaleWithLatinNumerics(culture || DEFAULT_CULTURE)

  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error memoized Intl.NumberFormat loses `this` context in types but works at runtime
    const formatter = getNumberFormat(locale, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })

    return formatter.format(value)
  } catch (error) {
    console.error('Failed to format number', error)
  }

  return `${value}`
}
